import Datetime from 'react-datetime';
import moment from 'moment';
import 'moment/locale/fr';
import classnames from 'classnames';

moment.locale('fr');

type Props = {
    label?: string;
    name?: string;
    defaultValue?: string | Date;
    onChange: Function;
    className?: string;
    dateFormat?: string;
};

const Datepicker: React.FC<Props> = ({
    label,
    name = '',
    defaultValue = '',
    onChange,
    className,
    dateFormat = 'YYYY-MM-DD',
}) => (
    <div id={`Datepicker-${name}`} className={classnames('col-sm-12 row', className)}>
        {label && <label className="mr-3 align-self-center">{label}:</label>}
        <Datetime
            dateFormat={dateFormat}
            inputProps={{ name: name }}
            initialValue={moment(defaultValue, dateFormat)}
            timeFormat={false}
            onChange={(val) => onChange(val ? moment(val).format(dateFormat) : null)}
        />
    </div>
);

export default Datepicker;
